// extracted by mini-css-extract-plugin
export default {"sort":"sort_filter_sort__CnXLj","label":"sort_filter_label__iRZYS","icon":"sort_filter_icon__hKPFu","active":"sort_filter_active__YIPTt","text":"sort_filter_text__uK0Rh"};